import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ClassDetailsIndex from '@routes/Home/routes/Curriculum/routes/ClassDetails/routes/ClassDetailsIndex';
import Attendance from '@routes/Home/routes/Curriculum/routes/ClassDetails/routes/Attendance';
import AttendanceInsights from '@routes/Home/routes/Curriculum/routes/ClassDetails/routes/AttendanceInsights';
import ClassExams from '@routes/Home/routes/Curriculum/routes/ClassDetails/routes/ClassExams';
import ExamDetails from './routes/ClassExams/ExamDetails';
import Homework from './routes/Homework';
import ClassSettings from './routes/ClassSettings';

const ClassDetailsLayoutLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ClassDetails' */ './components/ClassDetails')
);

const ClassDetailsGuardLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ClassDetails' */ './Guard/ClassDetailsGuard')
);

export default (store) => {
	return {
		path: 'my-classes/:classId',
		element: <AsyncLoading component={<ClassDetailsGuardLazy />} />,
		children: [
			{
				element: <AsyncLoading component={<ClassDetailsLayoutLazy />} />,
				children: [
					ClassDetailsIndex(store),
					Attendance(store),
					AttendanceInsights(store),
					ClassExams(store),
					Homework(store),
					ClassSettings(store),
				],
			},
			...ExamDetails(store),
		],
	};
};
